import { EBaseIcon } from '@spinwise/react-component-library/BaseIcon';

// Custom to this brand icons
enum EBrandIcons {
  FlagRu = 'flag-ru',
  FlagEn = 'flag-en',
  Plus = 'plus',
  Notifications = 'notifications',
  Verified = 'verified',
  VerifiedStatus = 'verified-status',
  Cashier = 'cashier',
  Loyalty = 'loyalty',
  Account = 'account',
  Bonuses = 'bonus',
  Help = 'help',
  Warning = 'warning',
  HeavyWarning = 'heavy-warning',
  CheckMark = 'check-mark',
  CheckMarkEmpty = 'check-mark-empty',
  CheckMarkRounded = 'check-mark-rounded',
  CheckMarkEmptyOpaque = 'check-mark-empty-opaque',
  CheckMarkSquare = 'check-mark-square',
  CheckMarkEmptyOpaqueSquare = 'check-mark-empty-opaque-square',
  CheckMarkSuccess = 'check-mark-success',
  CheckMarkDone = 'check-mark-done',
  Lock = 'lock',
  LockSmall = 'lock-small',
  LockCash = 'lock-cash',
  Calendar = 'calendar',
  MaxBet = 'max-bet',
  WagerSpins = 'wagersinps',
  WagerFunds = 'wager-funds',
  Spins = 'spins',
  Game = 'game',
  Info = 'info',
  ArrowLeftLongFat = 'arrow-left-long-fat',
  MinDep = 'min-dep',
  MinOdds = 'min-odds',
  Bullet = 'bullet',
  Decrease = 'decrease',
  Increase = 'increase',
  Resize = 'resize',
  Close = 'close',
  CloseSmall = 'close-small',
  Mark = 'mark',
  Age21 = 'age-21',
  CrossRound = 'cross-round',
  CrossRoundEmpty = 'cross-round-empty',
  Clock = 'clock',
  DotIcon = 'dot-icon',
  HelpMobile = 'help-mobile',
  MenuMobile = 'menu-mobile',
  PlayMobile = 'play-mobile',
  PlusMobile = 'plus-mobile',
  PlusBold = 'plus-bold',
  SignOut = 'sign-out',
  Home = 'home',
  Promotions = 'promotions',
  ArrowRight = 'arrow-right',
  AllGames = 'all-games',
  Star = 'star',
  Feature = 'feature',
  Megaways = 'megaways',
  PlusNoBg = 'plus-no-bg',
  Dots = 'dots',
  ArrowDown = 'arrow-down',
  ArrowLeftLong = 'arrow-left-long',
  ArrowRightLong = 'arrow-right-long',
  CrossSm = 'cross-sm',
  DarkMode = 'dark-mode',
  Dot = 'dot',
  Eye = 'eye',
  Filter = 'filter',
  Heart = 'heart',
  HeartOff = 'heart-off',
  HeartOn = 'heart-on',
  Loading = 'loading',
  MinusBig = 'minus-big',
  More = 'more',
  Play = 'play',
  Search = 'search',
  Tab = 'tab',
  Visibility = 'visibility',
  Wagering = 'wagering',
  Image = 'image',
  Document = 'document',
  MarkLine = 'mark-line',
  Burger = 'burger',
  CloseFat = 'close-fat',
  EmailAt = 'email-at',
  Cashback = 'cashback',
  DailyWithdraw = 'daily-withdraw',
  Ball = 'ball',
  TwoBoxes = 'two-boxes',
  Language = 'language',
  VisibilityOff = 'visibility-off',
  ArrowForward = 'arrow-forward',
  ArrowOutward = 'arrow-outward',
  Chat = 'chat',
  Instant = 'instant',
  TaxFree = 'tax-free',
  ToggleOff = 'toggle-off',
  ToggleOn = 'toggle-on',
  FreeBet = 'free-bet',
  PhotoCamera = 'photo-camera',
  WebTraffic = 'web-traffic',
  Folder = 'folder',
  SportTicket = 'sport-ticket',
  Smash = 'smash',
  ArrowUp = 'arrow-up',
}

export enum EBrandBigIcons {
  Warning = '/images/big-icons/warning.png',
  TakeBreaks = '/images/big-icons/take-breaks.png',
  Rubik = '/images/big-icons/rubik.png',
  CheckboxPaper = '/images/big-icons/checkbox_paper.png',
  PasswordLock = '/images/big-icons/password_lock.png',
  MailOpen = '/images/big-icons/mail_open.png',
  Profile = '/images/big-icons/profile.png',
  BankCards = '/images/big-icons/bank_cards.png',
  MoneyMachine = '/images/big-icons/money_machine.png',
  StopWatch = '/images/big-icons/stopwatch.png',
  StatusStop = '/images/big-icons/status_stop.png',
  StatusPause = '/images/big-icons/status_pause.png',
  PhoneStar = '/images/big-icons/phone_star.png',
  Priviliges = '/images/big-icons/priviliges.png',
  VipBonuses = '/images/big-icons/vip_bonuses.png',
  MonthlyBonuses = '/images/big-icons/monthly_bonuses.png',
  CakeBlue = '/images/big-icons/cake_blue.png',
  SpinsHotGames = '/images/big-icons/spins_hot_games.png',
  SupportContact = '/images/big-icons/support_contact.png',
  GiftBoxYellow = '/images/big-icons/gift_box_yellow.png',
}

export type EIcons = EBrandIcons | EBaseIcon | string;

export const IconLibrary = { ...EBrandIcons, ...EBaseIcon };
